/**
 * Custom Envy — Design of the Month Form Logic
 * Validation, file preview, fetch POST, Klaviyo events, honeypot.
 */
(function () {
  'use strict';

  var section = document.querySelector('[id^="ce-dotm-form-"]');
  if (!section) return;

  var endpoint = section.getAttribute('data-endpoint');
  var form = section.querySelector('.ce-dotm-form__form');
  var errorBanner = section.querySelector('.ce-dotm-form__error-banner');
  var successDiv = section.querySelector('.ce-dotm-form__success');
  var submitBtn = section.querySelector('.ce-dotm-form__submit');

  /* --- File state --- */
  var primaryFile = null;
  var additionalFiles = [];
  var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
  var ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];

  /* --- URL param pre-fill --- */
  var params = new URLSearchParams(window.location.search);
  if (params.get('email')) {
    var emailInput = form.querySelector('[name="email"]');
    if (emailInput) emailInput.value = params.get('email');
  }
  if (params.get('order')) {
    var orderInput = form.querySelector('[name="order_number"]');
    if (orderInput) orderInput.value = params.get('order');
  }

  /* ========================================
     VALIDATION
     ======================================== */

  function showFieldError(name, msg) {
    var el = section.querySelector('[data-for="' + name + '"]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    var input = form.querySelector('[name="' + name + '"]');
    if (input) input.classList.add('has-error');
  }

  function clearFieldError(name) {
    var el = section.querySelector('[data-for="' + name + '"]');
    if (!el) return;
    el.textContent = '';
    el.classList.remove('is-visible');
    var input = form.querySelector('[name="' + name + '"]');
    if (input) input.classList.remove('has-error');
  }

  function clearAllErrors() {
    section.querySelectorAll('.ce-dotm-form__field-error').forEach(function (el) {
      el.textContent = '';
      el.classList.remove('is-visible');
    });
    form.querySelectorAll('.has-error').forEach(function (el) {
      el.classList.remove('has-error');
    });
    errorBanner.textContent = '';
    errorBanner.classList.remove('is-visible');
  }

  function validateField(name) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) return true;
    var val = input.value.trim();

    switch (name) {
      case 'first_name':
      case 'last_name':
        if (!val) { showFieldError(name, 'This field is required.'); return false; }
        if (val.length < 2) { showFieldError(name, 'Must be at least 2 characters.'); return false; }
        break;
      case 'email':
        if (!val) { showFieldError(name, 'Email is required.'); return false; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { showFieldError(name, 'Please enter a valid email.'); return false; }
        break;
      case 'order_number':
        if (!val) { showFieldError(name, 'Order number is required.'); return false; }
        break;
      case 'design_description':
        if (!val) { showFieldError(name, 'Please describe what you created.'); return false; }
        if (val.length > 200) { showFieldError(name, 'Must be 200 characters or fewer.'); return false; }
        break;
      case 'story':
        if (!val) { showFieldError(name, 'Please tell us your story.'); return false; }
        if (val.length < 50) { showFieldError(name, 'Story must be at least 50 characters.'); return false; }
        if (val.length > 1000) { showFieldError(name, 'Story must be 1000 characters or fewer.'); return false; }
        break;
    }
    clearFieldError(name);
    return true;
  }

  function validateAll() {
    var valid = true;
    ['first_name', 'last_name', 'email', 'order_number', 'design_description', 'story'].forEach(function (name) {
      if (!validateField(name)) valid = false;
    });
    // Photo required
    if (!primaryFile) {
      showFieldError('photo_primary', 'A photo is required.');
      valid = false;
    }
    // Consent
    var consent = form.querySelector('[name="consent"]');
    if (!consent.checked) {
      showFieldError('consent', 'You must agree to the Official Rules to submit.');
      valid = false;
    }
    return valid;
  }

  /* --- Blur validation --- */
  ['first_name', 'last_name', 'email', 'order_number', 'design_description', 'story'].forEach(function (name) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) return;
    input.addEventListener('blur', function () { validateField(name); });
  });

  /* --- Character counters --- */
  ['design_description', 'story', 'additional_notes'].forEach(function (name) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) return;
    var counter = section.querySelector('[data-count="' + name + '"]');
    if (!counter) return;
    var max = parseInt(input.getAttribute('maxlength'), 10) || 9999;
    input.addEventListener('input', function () {
      var len = input.value.length;
      counter.textContent = len;
      counter.parentElement.classList.toggle('is-over', len > max);
    });
  });

  /* ========================================
     FILE HANDLING
     ======================================== */

  function isValidFile(file) {
    if (!ALLOWED_TYPES.includes(file.type) && !file.name.match(/\.heic$/i) && !file.name.match(/\.heif$/i)) {
      return 'File type not supported. Please use JPG, PNG, or HEIC.';
    }
    if (file.size > MAX_FILE_SIZE) {
      return 'File is too large. Maximum size is 10 MB.';
    }
    return null;
  }

  function createPreview(file, container, removeCallback) {
    var div = document.createElement('div');
    div.className = 'ce-dotm-form__preview';
    var img = document.createElement('img');
    img.src = URL.createObjectURL(file);
    img.alt = 'Preview';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ce-dotm-form__preview-remove';
    btn.innerHTML = '&times;';
    btn.setAttribute('aria-label', 'Remove photo');
    btn.addEventListener('click', function () {
      URL.revokeObjectURL(img.src);
      div.remove();
      removeCallback();
    });
    div.appendChild(img);
    div.appendChild(btn);
    container.appendChild(div);
  }

  /* Primary photo */
  var primaryZone = section.querySelector('[data-upload="primary"]');
  var primaryInput = section.querySelector('[data-upload-input="primary"]');
  var primaryPreviews = section.querySelector('[data-previews="primary"]');

  primaryZone.addEventListener('click', function () { primaryInput.click(); });
  primaryZone.addEventListener('dragover', function (e) { e.preventDefault(); primaryZone.classList.add('is-dragover'); });
  primaryZone.addEventListener('dragleave', function () { primaryZone.classList.remove('is-dragover'); });
  primaryZone.addEventListener('drop', function (e) {
    e.preventDefault();
    primaryZone.classList.remove('is-dragover');
    if (e.dataTransfer.files.length) handlePrimaryFile(e.dataTransfer.files[0]);
  });
  primaryInput.addEventListener('change', function () {
    if (primaryInput.files.length) handlePrimaryFile(primaryInput.files[0]);
  });

  function handlePrimaryFile(file) {
    var err = isValidFile(file);
    if (err) { showFieldError('photo_primary', err); return; }
    clearFieldError('photo_primary');
    primaryFile = file;
    primaryPreviews.innerHTML = '';
    createPreview(file, primaryPreviews, function () {
      primaryFile = null;
      primaryInput.value = '';
    });
  }

  /* Additional photos */
  var additionalZone = section.querySelector('[data-upload="additional"]');
  var additionalInput = section.querySelector('[data-upload-input="additional"]');
  var additionalPreviews = section.querySelector('[data-previews="additional"]');

  additionalZone.addEventListener('click', function () { additionalInput.click(); });
  additionalZone.addEventListener('dragover', function (e) { e.preventDefault(); additionalZone.classList.add('is-dragover'); });
  additionalZone.addEventListener('dragleave', function () { additionalZone.classList.remove('is-dragover'); });
  additionalZone.addEventListener('drop', function (e) {
    e.preventDefault();
    additionalZone.classList.remove('is-dragover');
    handleAdditionalFiles(e.dataTransfer.files);
  });
  additionalInput.addEventListener('change', function () {
    handleAdditionalFiles(additionalInput.files);
  });

  function handleAdditionalFiles(files) {
    clearFieldError('photo_additional');
    var remaining = 3 - additionalFiles.length;
    if (remaining <= 0) {
      showFieldError('photo_additional', 'Maximum 3 additional photos.');
      return;
    }
    for (var i = 0; i < Math.min(files.length, remaining); i++) {
      var err = isValidFile(files[i]);
      if (err) { showFieldError('photo_additional', err); return; }
      var file = files[i];
      additionalFiles.push(file);
      (function (f, idx) {
        createPreview(f, additionalPreviews, function () {
          var pos = additionalFiles.indexOf(f);
          if (pos > -1) additionalFiles.splice(pos, 1);
        });
      })(file, additionalFiles.length - 1);
    }
  }

  /* ========================================
     SUBMIT
     ======================================== */

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearAllErrors();

    /* Honeypot check */
    var hp = form.querySelector('[name="website"]');
    if (hp && hp.value) {
      /* Bot detected — fake success */
      form.style.display = 'none';
      successDiv.classList.add('is-visible');
      return;
    }

    if (!validateAll()) return;

    /* Build FormData */
    var fd = new FormData();
    fd.append('first_name', form.querySelector('[name="first_name"]').value.trim());
    fd.append('last_name', form.querySelector('[name="last_name"]').value.trim());
    fd.append('email', form.querySelector('[name="email"]').value.trim());
    fd.append('order_number', form.querySelector('[name="order_number"]').value.trim());
    fd.append('design_description', form.querySelector('[name="design_description"]').value.trim());
    fd.append('story', form.querySelector('[name="story"]').value.trim());
    fd.append('consent', 'true');

    var ig = form.querySelector('[name="instagram_handle"]').value.trim();
    if (ig) fd.append('instagram_handle', ig);

    var notes = form.querySelector('[name="additional_notes"]').value.trim();
    if (notes) fd.append('additional_notes', notes);

    fd.append('photo_primary', primaryFile);
    additionalFiles.forEach(function (f, i) {
      fd.append('photo_additional_' + (i + 1), f);
    });

    /* Loading state */
    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;

    fetch(endpoint, {
      method: 'POST',
      body: fd
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { status: res.status, data: data };
        });
      })
      .then(function (result) {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;

        if (result.status === 200 || result.status === 201) {
          /* Success */
          form.style.display = 'none';
          successDiv.classList.add('is-visible');
          successDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });

          /* Klaviyo events */
          if (typeof klaviyo !== 'undefined') {
            var email = fd.get('email');
            var firstName = fd.get('first_name');
            var lastName = fd.get('last_name');
            klaviyo.push(['identify', {
              $email: email,
              $first_name: firstName,
              $last_name: lastName
            }]);
            klaviyo.push(['track', 'Submitted Design of the Month', {
              order_number: fd.get('order_number'),
              design_description: fd.get('design_description'),
              has_instagram: !!ig,
              photo_count: 1 + additionalFiles.length,
              story_length: fd.get('story').length
            }]);
          }
        } else if (result.status === 409) {
          errorBanner.textContent = result.data.error || "It looks like you've already submitted an entry for this order. Want to submit for a different order?";
          errorBanner.classList.add('is-visible');
          errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          errorBanner.textContent = result.data.error || 'Something went wrong. Please try again.';
          errorBanner.classList.add('is-visible');
          errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      })
      .catch(function () {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
        errorBanner.textContent = 'Network error. Please check your connection and try again.';
        errorBanner.classList.add('is-visible');
        errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
  });
})();
